import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles, Theme } from '@material-ui/core/styles';

import StatusChip from 'components/@common/StatusChip';

import { UserStatus } from 'types/schema-generated-types';

const useStyles = makeStyles((theme: Theme) => {
  return {
    avatar: {
      height: 80,
      width: 80
    },
    userDetailsContainer: {
      paddingTop: theme.spacing(),
      paddingBottom: theme.spacing()
    },
    actionButtonsContainer: {
      justifySelf: 'flex-end'
    }
  };
});

interface UserStatusHeaderProps {
  avatarUrl: string;
  firstName: string;
  lastName: string;
  userStatus?: UserStatus;
}

const UserHeaderStatus = ({
  avatarUrl,
  firstName,
  lastName,
  userStatus
}: UserStatusHeaderProps): React.ReactElement => {
  const classes = useStyles();
  return (
    <Grid container direction="row" wrap="nowrap" spacing={2}>
      <Grid item>
        <Avatar src={avatarUrl || ''} className={classes.avatar} />
      </Grid>
      <Grid item container direction="column" className={classes.userDetailsContainer}>
        <Grid item>
          <Typography variant="h4">
            {firstName} {lastName}
          </Typography>
        </Grid>
        <Grid item>
          <StatusChip status={userStatus || UserStatus.PENDING} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserHeaderStatus;
